import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["copiedNotice"]
  static values = { fill: String }

  copyToClipboard(textToCopy) {
    let noticeText = "Copied"

    if (navigator.clipboard?.writeText) {
      window.navigator.clipboard.writeText(textToCopy)
      noticeText = `Copied: ${textToCopy}`
    } else {
      noticeText = `Manually copy here: ${textToCopy}`
    }

    this.showCopiedNotice(noticeText)

    setTimeout(() => {
      this.hideCopiedNotice()
    }, 5000)
  }

  copy(event) {
    event.preventDefault()
    const text = event.currentTarget.dataset.copy
    this.copyToClipboard(text)
  }

  fill(event) {
    event.preventDefault()
    const text = event.currentTarget.dataset.copy
    const input = document.querySelector(this.fillValue)
    if (input) {
      input.value = text
    }
  }

  hideCopiedNotice() {
    const onTransitionEnd = () => {
      this.copiedNoticeTarget.classList.add("hidden")
      this.copiedNoticeTarget.removeEventListener("transitionend", onTransitionEnd)
    }

    this.copiedNoticeTarget.addEventListener("transitionend", onTransitionEnd, { once: true })

    this.copiedNoticeTarget.classList.remove("opacity-100")
    this.copiedNoticeTarget.classList.add("opacity-0")
  }

  showCopiedNotice(text) {
    this.copiedNoticeTarget.innerText = text

    this.copiedNoticeTarget.classList.remove("hidden")

    requestAnimationFrame(() => {
      this.copiedNoticeTarget.classList.remove("opacity-0")
      this.copiedNoticeTarget.classList.add("opacity-100")
    })
  }
}
